import React from "react";
import PropTypes from "prop-types";

const Icon = props => (
  <div className={props.className}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
    >
      <path
        d="M0.625 0.25L5 4.625L9.375 0.25L0.625 0.25Z"
        fill="black"
        fillOpacity="0.67"
      />
    </svg>
  </div>
);

const ColumnHeader = ({ text, order, sortable }) => {
  return (
    <div className={sortable && "mydpd-table-sort"}>
      {text}
      {sortable && (
        <div className="mydpd-table-sort-icon">
          <Icon
            className={`mydpd-table-sort-icon-asc ${order === true &&
              "mydpd-table-sort-icon-selected"}`}
          />
          <Icon
            className={`mydpd-table-sort-icon-desc ${order === false &&
              "mydpd-table-sort-icon-selected"}`}
          />
        </div>
      )}
    </div>
  );
};

ColumnHeader.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  order: PropTypes.bool,
  sortable: PropTypes.bool,
};

Icon.propTypes = {
  className: PropTypes.string,
};

export default ColumnHeader;
